import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';  // import the CSS file
import googlePlayBadge from './images/google-play-badge.png';
import appleBadge from './images/Apple badge.png';


const RedirectPage = () => {
  const [showDownload, setShowDownload] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const deepLink = urlParams.get('link') || urlParams.get('dl');
    const fixtureId = urlParams.get('fixture') || urlParams.get('f');

    let appDeepLink = '';

    if (deepLink) {
      appDeepLink = decodeURIComponent(deepLink);
    } else if (fixtureId) {
      appDeepLink = `wazzascore://fixture_details/${fixtureId}`;
    }

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);
    const isMobile = isIOS || isAndroid;

    const tryOpenApp = () => {
      if (!appDeepLink) {
        setShowDownload(true);
        return;
      }

      if (!isMobile) {
        setShowDownload(true);
        return;
      }

      if (isIOS) {
        window.location = appDeepLink;
        setTimeout(() => {
          window.location = 'https://apps.apple.com/app/wazzascore';
        }, 2500);
      } else if (isAndroid) {
  const intentUrl = 
    `intent://fixture_details/${fixtureId || 'default'}#` +
    `Intent;scheme=wazzascore;` +
    `package=com.wazzascoreapp;` +
    `S.browser_fallback_url=https://play.google.com/store/apps/details?id=com.wazzascoreapp;` +
    `end`;
  window.location = intentUrl;
}

      setTimeout(() => setShowDownload(true), 3000);
    };

    const timer = setTimeout(tryOpenApp, 500);

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        setTimeout(() => setShowDownload(true), 1000);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [location]);

  const handleTryAgain = () => {
    window.location.reload();
  };

  return (
    <div className="redirect-page">
      <div className="redirect-container">
        <div className="redirect-logo" aria-label="WazzaScore logo">
            <img 
              src={`${process.env.PUBLIC_URL}/WazzaScore_Icon.png`} 
              alt="WazzaScore logo" 
              style={{ width: '60px', height: '60px', objectFit: 'contain' }} 
            />
          </div>


        {!showDownload ? (
          <>
            <h1 className="heading">Opening WazzaScore...</h1>
            <div className="spinner" />
            <p className="text">If the app doesn't open automatically, you can download it below.</p>
          </>
        ) : (
          <>
            <h1 className="heading">Get WazzaScore App to view this fixture!</h1>
            <p className="text">
              Download the app to get live scores, match updates, and never miss a moment!
            </p>

            <div className="download-section">
                <div className="GooglePlayButtonDiv">
                  <a
                      href="https://play.google.com/store/apps/details?id=com.wazzascoreapp"
                      className="GooglePlayButton"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={googlePlayBadge} alt="Google Play Badge" className="Badge" />
                    </a>

                  <div className="AppStoreDiv">
                    <a
                      href="https://apps.apple.com/be/app/wazzascore/id6737886101"
                      className="AppStoreButton"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={appleBadge} alt="App Store Badge" className="Badge" />
                    </a>
                  </div>
                </div>
              </div>


            <button onClick={handleTryAgain} className="try-again-btn">
              Already have the app? Try opening it again
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default RedirectPage;
